export default function Article6() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/594dc4849304cbd3bd7a23edd8bf4d32/085c019ea1217b73a4a5e1e39cd86a89.jpeg"
                alt="PROTECPLUS INGENIERÍA"
                className="h-16 w-auto"
              />
            </a>
            <div className="flex gap-4">
              <a 
                href="/blog"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                Volver al Blog
              </a>
              <a 
                href="/"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-home-line mr-2"></i>
                Inicio
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Article Content */}
      <article className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Article Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4">
            <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full font-medium">
              Normativas
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-calendar-line"></i>
              <span>15 Diciembre 2024</span>
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-time-line"></i>
              <span>6 min lectura</span>
            </span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Formación Obligatoria en Seguridad Industrial 2025
          </h1>
          
          <div className="w-full h-96 rounded-2xl overflow-hidden mb-8">
            <img 
              src="https://public.readdy.ai/ai/img_res/4103166c75392ef74a89592473ac1ec1.jpg"
              alt="Formación Obligatoria en Seguridad Industrial"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Article Body */}
        <div className="prose prose-lg max-w-none">
          <div className="bg-emerald-50 border-l-4 border-emerald-500 p-6 rounded-r-lg mb-8">
            <p className="text-gray-700 font-medium">
              La formación en seguridad industrial es un requisito legal fundamental. Esta guía actualiza los requisitos de formación obligatoria para trabajadores en instalaciones industriales según la legislación vigente en 2025.
            </p>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Marco Normativo</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            La formación en seguridad industrial está regulada por:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li><strong>Ley 31/1995:</strong> Prevención de Riesgos Laborales</li>
            <li><strong>RD 39/1997:</strong> Reglamento de los Servicios de Prevención</li>
            <li><strong>RD 2267/2004:</strong> Reglamento de Seguridad contra Incendios en Establecimientos Industriales</li>
            <li><strong>Normativa sectorial específica:</strong> Según tipo de instalación</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Formación Básica Obligatoria</h2>
          
          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Prevención de Riesgos Laborales</h3>
          <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
            <p className="text-gray-700 mb-4">
              Todos los trabajadores deben recibir formación en PRL adaptada a su puesto:
            </p>
            <ul className="text-gray-700 space-y-2">
              <li><strong>Duración mínima:</strong> 6 horas (nivel básico)</li>
              <li><strong>Contenidos:</strong> Riesgos del puesto, medidas preventivas, primeros auxilios</li>
              <li><strong>Periodicidad:</strong> Inicial y cuando cambien las condiciones de trabajo</li>
              <li><strong>Certificación:</strong> Obligatoria por entidad acreditada</li>
            </ul>
          </div>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. Protección contra Incendios</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Formación específica en prevención y extinción de incendios:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li><strong>Teoría del fuego:</strong> Tipos de fuego y métodos de extinción</li>
            <li><strong>Uso de extintores:</strong> Práctica con fuego real</li>
            <li><strong>Evacuación:</strong> Procedimientos y vías de escape</li>
            <li><strong>Equipos de emergencia:</strong> BIEs, alarmas, sistemas automáticos</li>
          </ul>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. Primeros Auxilios</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Obligatorio para trabajadores designados como socorristas:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Evaluación inicial de la víctima</li>
            <li>Reanimación cardiopulmonar (RCP)</li>
            <li>Control de hemorragias</li>
            <li>Tratamiento de quemaduras</li>
            <li>Inmovilización y transporte</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Formación Específica por Sectores</h2>
          
          <div className="space-y-6 mb-8">
            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-fire-line text-emerald-600 text-xl"></i>
                <span>Instalaciones Petrolíferas</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Operador de instalaciones petrolíferas (ITC MI-IP 04)</li>
                <li>• Duración: 25 horas teóricas + 15 prácticas</li>
                <li>• Renovación: Cada 5 años</li>
                <li>• Certificado oficial obligatorio</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-flashlight-line text-emerald-600 text-xl"></i>
                <span>Instalaciones Eléctricas</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Riesgo eléctrico según RD 614/2001</li>
                <li>• Trabajos en tensión o proximidad</li>
                <li>• Duración: 20-50 horas según nivel</li>
                <li>• Autorización de la empresa obligatoria</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-temp-cold-line text-emerald-600 text-xl"></i>
                <span>Instalaciones Frigoríficas</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Manipulación de gases fluorados</li>
                <li>• Certificado según Reglamento (UE) 2024/573</li>
                <li>• Duración: 80 horas (certificado tipo I)</li>
                <li>• Renovación: Cada 5 años</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-space-ship-line text-emerald-600 text-xl"></i>
                <span>Espacios Confinados</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Identificación y evaluación de riesgos</li>
                <li>• Equipos de protección respiratoria</li>
                <li>• Procedimientos de rescate</li>
                <li>• Duración: 8 horas mínimo</li>
              </ul>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Equipos de Emergencia</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Las empresas deben designar y formar equipos de emergencia:
          </p>
          
          <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
            <h4 className="font-semibold text-gray-900 mb-4">Composición del Equipo</h4>
            <ul className="text-gray-700 space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-user-star-line text-emerald-600 text-xl mt-0.5"></i>
                <div>
                  <strong>Jefe de Emergencia:</strong> Coordina la respuesta y toma decisiones
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-team-line text-emerald-600 text-xl mt-0.5"></i>
                <div>
                  <strong>Equipo de Primera Intervención (EPI):</strong> Actúa en primeros minutos
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-shield-user-line text-emerald-600 text-xl mt-0.5"></i>
                <div>
                  <strong>Equipo de Segunda Intervención (ESI):</strong> Apoyo especializado
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-first-aid-kit-line text-emerald-600 text-xl mt-0.5"></i>
                <div>
                  <strong>Equipo de Primeros Auxilios (EPA):</strong> Atención a heridos
                </div>
              </li>
            </ul>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Formación Continua y Reciclaje</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            La formación debe actualizarse periódicamente:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li><strong>Simulacros:</strong> Al menos uno anual</li>
            <li><strong>Reciclaje teórico:</strong> Cada 2-3 años</li>
            <li><strong>Práctica con extintores:</strong> Anual recomendado</li>
            <li><strong>Actualización normativa:</strong> Cuando haya cambios legislativos</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Obligaciones del Empresario</h2>
          <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
            <ol className="list-decimal pl-6 text-gray-700 space-y-3">
              <li>Identificar necesidades formativas de cada puesto</li>
              <li>Proporcionar formación adecuada y suficiente</li>
              <li>Garantizar que la formación se imparte en horario laboral</li>
              <li>Mantener registros de toda la formación impartida</li>
              <li>Evaluar la eficacia de la formación</li>
              <li>Actualizar la formación cuando sea necesario</li>
            </ol>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Documentación Obligatoria</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            La empresa debe conservar:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Certificados de formación de todos los trabajadores</li>
            <li>Programas formativos y contenidos impartidos</li>
            <li>Registros de asistencia a cursos</li>
            <li>Acreditaciones de formadores</li>
            <li>Evaluaciones de conocimientos adquiridos</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Sanciones por Incumplimiento</h2>
          <div className="bg-red-50 border border-red-200 rounded-xl p-6 mb-8">
            <h4 className="font-semibold text-red-900 mb-3">Infracciones y Multas</h4>
            <ul className="text-red-800 space-y-2">
              <li><strong>Leves:</strong> 45 a 2.450 euros</li>
              <li><strong>Graves:</strong> 2.451 a 49.180 euros</li>
              <li><strong>Muy graves:</strong> 49.181 a 983.736 euros</li>
              <li><strong>Paralización de actividad:</strong> En casos de riesgo grave e inminente</li>
            </ul>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Recomendaciones Prácticas</h2>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Planificar la formación al inicio de cada año</li>
            <li>Utilizar plataformas online para formación teórica</li>
            <li>Realizar prácticas con equipos reales</li>
            <li>Documentar todo el proceso formativo</li>
            <li>Integrar la formación en la cultura de seguridad</li>
          </ul>

          {/* CTA Box */}
          <div className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl p-8 text-white mt-12">
            <h3 className="text-2xl font-bold mb-4">¿Necesitas formación en seguridad industrial?</h3>
            <p className="mb-6 text-emerald-50">
              Impartimos todos los cursos obligatorios con certificación oficial. Formación presencial y online.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/citas"
                className="bg-white text-emerald-600 px-6 py-3 rounded-lg font-semibold hover:bg-emerald-50 transition-all text-center whitespace-nowrap"
              >
                Solicitar Información
              </a>
              <a 
                href="/#contacto"
                className="bg-emerald-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-800 transition-all text-center whitespace-nowrap"
              >
                Ver Cursos
              </a>
            </div>
          </div>
        </div>

        {/* Back to Blog */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a 
            href="/blog"
            className="inline-flex items-center space-x-2 text-emerald-600 font-semibold hover:text-emerald-700 transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            <span>Volver al Blog</span>
          </a>
        </div>
      </article>
    </div>
  );
}